import request from '@/plugins/axios'

//获取标签列表
export function list(params) {
  return request({
    url: '/customLabel/list',
    method: 'get',
    params
  })
}

//添加标签
export function addLabel(data) {
  return request({
    url: '/customLabel/addLabel',
    method: 'post',
    data
  })
}

//删除标签
export function deleteLabel(params) {
  return request({
    url: '/customLabel/deleteLabel/' + params,
    method: 'get'
  })
}

//查询单个标签
export function getLabel(params) {
  return request({
    url: '/customLabel/getLabel/' + params,
    method: 'get'
  })
}
